import styled from "styled-components";
import Tooltip from "../tooltip";
import {
  getUserFriendlyMethodName,
  getMethodDescription,
} from "../../utils/transactionFormatter";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const MethodName = styled.div`
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TechnicalName = styled.div`
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default function CallCell({ call }) {
  if (!call) {
    return "--";
  }

  const { section, method } = call;
  const friendlyName = getUserFriendlyMethodName(section, method);
  const description = getMethodDescription(section, method);
  const technicalName = `${section}.${method}`;

  return (
    <Tooltip tip={description || technicalName}>
      <Wrapper>
        <MethodName>{friendlyName}</MethodName>
        <TechnicalName>{technicalName}</TechnicalName>
      </Wrapper>
    </Tooltip>
  );
}
